module.exports = __webpack_public_path__ + "img/stitch.4aaefa08.svg";